import { setCookie, getCookie } from '../utils/cookies';

let abortController;

let cartId = JSON.parse(getCookie('cart-id'));

const token = document.querySelector('meta[name="csrf-token"]').content;

const queryStore = async (endpoint, params) => {
  const response = await fetch(`/actions/businesslogic/product/${endpoint}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': token,
      'Accept': 'application/json',
    },
    body: JSON.stringify(params),
  })
  .then(res => res.json())
  .then(data => {
    return data;
  });

  if (!response.data) {
    throw new Error(`Error fetching data from ${endpoint}: ${response.errors[0].message ?? response.message}`);
  }

  return response;
};

const init = () => {
  const buyBtn = document.querySelector('.js-buy-btn');
  const cartModal = document.querySelector('.js-cart');
  if (!cartModal) return;
  const cartList = cartModal.querySelector('.js-cart-list');
  if (!cartList) return;
  const cartItemTemplate = cartList.querySelector('template.js-cart-item');
  const checkoutBtn = cartModal.querySelector('.js-cart-checkout');

  const getQtyInputs = () => {
    const qtyInputs = document.querySelectorAll(
      '.js-cart-item-qty input:not(.is-initialized)',
    );
    qtyInputs.forEach(qtyInput => {
      qtyInput.classList.add('is-initialized');
      qtyInput.addEventListener('change', async () => {
        qtyInput.parentElement.classList.add('is-loading');
        const { data } = await queryStore('cart-lines-update', {
          cartId,
          lines: [
            {
              id: qtyInput.id,
              quantity: parseInt(qtyInput.value),
            },
          ],
        });

        updateCart(
          data.cartLinesUpdate.cart.lines.edges,
          data.cartLinesUpdate.cart.cost.subtotalAmount,
        );
      });
    });
  };

  const updateCart = (lines, total, openCart = false) => {
    const cartItemsForm = cartModal.querySelector('.js-cart-items-form');
    const linesIds = lines.map(line =>
      line.node.merchandise.product.id.split('/').pop(),
    );

    abortController = new AbortController();
    const { signal } = abortController;

    cartItemsForm.querySelector('input[name="ids"]').value =
      JSON.stringify(linesIds);
    const data = new FormData(cartItemsForm);
    const action = cartItemsForm.getAttribute('action');
    const url = `${action}?${new URLSearchParams(data).toString()}`;

    fetch(url, { signal })
      .then(response => response.json())
      .then(res => {
        cartList.innerHTML = '';

        const cartQty = lines.reduce((acc, line) => {
            return acc + line.node.quantity;
        }, 0);

        if (cartQty === 0) {
            cartModal.modal.closeModal();
        }

        lines
        .map(line => line.node)
        .forEach(item => {
            if (!cartItemTemplate) return;
            const productId = item.merchandise.product.id
                .split('/')
                .pop();
            const cartItem = document.importNode(
                cartItemTemplate.content,
                true,
            );
            const product = res[productId];
            const cartItemQuantity = cartItem.querySelector(
                '.js-cart-item-qty input',
            );
            cartItemQuantity.id = item.id;
            const cartItemLink =
                cartItem.querySelector('.js-cart-item-link');
            cartItemLink.href = product.url;
            cartItemQuantity.value = item.quantity;
            const cartItemTitle = cartItem.querySelector(
                '.js-cart-item-title',
            );
            cartItemTitle.textContent = product.title;
            const cartItemArtist = cartItem.querySelector(
                '.js-cart-item-artist',
            );
            cartItemArtist.textContent = product.artist;
            const cartItemPrice = cartItem.querySelector(
                '.js-cart-item-price',
            );
            const cartItemCategory = cartItem.querySelector(
                '.js-cart-item-category',
            );
            cartItemCategory.textContent = product.category;
            const cartItemImage =
                cartItem.querySelector('.js-cart-item-img');
            cartItemImage.src = product.image.url;
            cartItemImage.alt = product.image.altText;
            cartItemPrice.textContent = product.price + '€';
            cartList.appendChild(cartItem);

            const cartQtyTots =
                document.querySelectorAll('.js-cart-qty');

            cartQtyTots.forEach(cartQtyTot => {
                cartQtyTot.textContent = cartQty;
            });

            const qtyInputs =
                document.querySelectorAll('.js-cart-item-qty');
            qtyInputs.forEach(qtyInput => {
                qtyInput.classList.remove('is-loading');
            });

            getQtyInputs();

            if (openCart) cartModal.modal.openModal();
        });
      })
      .catch(err => {
        if (err.name === 'AbortError') return;
        console.warn(err);
      });
  };

  if (cartId) {
    setTimeout(async () => {
      const { data } = await queryStore('get-cart', {
        cartId,
      });

      if (checkoutBtn) {
        checkoutBtn.href = data.cart.checkoutUrl;
      }

      updateCart(data.cart.lines.edges, data.cart.cost.subtotalAmount);
    }, 100);
  }

  buyBtn.addEventListener('click', async () => {
    const variantId = buyBtn.dataset.variantId;
    const lines = [
    {
        quantity: 1,
        merchandiseId: variantId,
    },
    ];

    if (cartId) {
    const { data } = await queryStore('cart-lines-add', {
        cartId,
        lines,
    });

    updateCart(
        data.cartLinesAdd.cart.lines.edges,
        data.cartLinesAdd.cart.cost.subtotalAmount,
    );
    } else {
      const { data } = await queryStore('cart-create', {
          input: {
          lines,
          },
      });

      cartId = data.cartCreate.cart.id;
      setCookie('cart-id', JSON.stringify(cartId), 1);
      checkoutBtn.href = data.cartCreate.cart.checkoutUrl;

      updateCart(
          data.cartCreate.cart.lines.edges,
          data.cartCreate.cart.cost.subtotalAmount,
      );
    }
  });
};

const module = () => {
  window.addEventListener('load', init);
};

export default module;
